/**
 * フェードインモジュール
 *
 * ・対象要素（.ist-js__fadeIn）のbottomが
 *   scrollTop + innerHeight（ビューポートの下端）に入った場合、
 *   またはtopがscrollTop + innerHeight / 2（ビューポートの中央）に入った場合に
 *   ist-js__fadeIn--active クラスを付与する。
 */
export class FadeInManager {
  private fadeInItems: NodeListOf<HTMLElement>;
  private prevScrollY: number = window.scrollY; // 前回のスクロール位置を保持

  constructor() {
    // 対象要素を取得
    this.fadeInItems = document.querySelectorAll('.ist-js__fadeIn');
    this.init();
  }

  private init(): void {
    // スクロール・リサイズ時に状態を更新
    window.addEventListener('scroll', this.update.bind(this));
    window.addEventListener('resize', this.update.bind(this));
    // 初期表示時にも状態を更新
    this.update();
  }

  private update(): void {
    const currentScrollY = window.scrollY;
    const isScrollingUp = currentScrollY < this.prevScrollY;

    this.fadeInItems.forEach((item) => {
      const rect = item.getBoundingClientRect();

      // 条件により active クラスを付与
      if (
        rect.bottom <= window.innerHeight ||
        rect.top <= window.innerHeight / 2
      ) {
        item.classList.add('ist-js__fadeIn--active');
      }
      // すでに active で、かつ上方向スクロール中に対象要素の top が viewport の下端より下にある場合は active クラスを削除
      if (isScrollingUp && rect.top > window.innerHeight) {
        item.classList.remove('ist-js__fadeIn--active');
      }
    });

    // 現在のスクロール位置を保持
    this.prevScrollY = currentScrollY;
  }
}
